import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
// import { numberWithCommas, mFormatter, kmFormatter } from "../../../../../../MainContent/Dashboard/Charts/utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import { numberWithCommas } from "../../../../../Dashboard/utils";
import { kmFormatter } from "../../../../../Dashboard/Charts/utils";
HighchartsCustomEvents(Highcharts);

class CompetitorByHashtagsChart extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
        this.legendAlign = this.props.isCompPage ? "right" : "center";
    }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            this.chartComponent?.current?.chart?.setSize(null, null);
            this.chartComponent?.current?.chart?.reflow();
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        }
    }

    componentWillUnmount() {
        this.ro?.disconnect();
    }

    getBarOptions() {
        // const data = this.props.data;
        let series = this.props.data;

        // this.props.data.forEach((d) => {
        //     series.push({ name: d.key, data: [{ name: d.key, y: d.doc_count }] });
        // });

        const barOptions = {
            chart: {
                type: "column",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            legend: {
                enabled: this.props.showLegend,
                // align: this.legendAlign,
                alignColumns: false,
            },
            plotOptions: {
                series: {
                    // stacking: "normal",
                },
                column: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        inside: false,
                        enabled: this.props.showLabel,
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                        formatter: function () {
                            return `<b>${kmFormatter(this.y)}</b>`;
                            // return `<b>${this.y}</b>`;
                        },
                    },
                    point: {},
                },
                // bar: {
                //     shadow: false,
                //     showInLegend: true,
                //     dataLabels: {
                //         enabled: this.props.showLabel,
                //         formatter: function () {
                //             return `<span>${kmFormatter(this.point.y)}</span>
                //         `;
                //         },
                //         inside: false,
                //         style: {
                //             color: "#333333",
                //         },

                //         pointWidth: 15,
                //         stacking: "normal",
                //     },
                // },
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            xAxis: {
                // categories: this.props.chartData.LocationWithData || [],
                type: "category",
                lineWidth: 1,
                labels: {
                    // useHTML: true,
                    style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "",
            },
            tooltip: {
                backgroundColor: "#fff",
                opacity: 1,
                // zIndex: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                },
                formatter: function () {
                    return `<b>${this.point.name}</b> | <b> ${this.y}`;
                    // return `<span>${this.series.name}</span> <br/> : <b>${this.series?.userOptions?.data?.[0]?.y || 0}   </b>
                },
            },
            series: series || [],
        };
        return barOptions;
    }

    render() {
        if (!this.props.data) return null;

        return (
            <HighchartsReact
                highcharts={Highcharts}
                // options={this.props.graphType == "bar" ? this.getBarOptions() : this.getPieOptions()}
                options={this.getBarOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
            />
        );
    }
}

export default CompetitorByHashtagsChart;
